import { createFileRoute } from '@tanstack/react-router'
import { HttpStatusPage, httpStatusHead } from '@/components/http-status-page'
import type { HttpStatusData } from '@/components/http-status-page'

const data: HttpStatusData = {
  code: 404,
  name: 'Not Found',
  description:
    'The server cannot find the requested resource. The URL does not match any known route or file on the server. This is the most common HTTP error users encounter.',
  causes: [
    'The URL is misspelled or contains a typo. A single wrong character in the path makes the resource unreachable.',
    'The resource was deleted or moved without setting up a redirect. Old bookmarks and external links now point to nothing.',
    'The server-side routing is misconfigured — the route exists in code but the web server or reverse proxy does not forward the request correctly.',
  ],
  fixes: [
    'Verify the URL is correct. Check for typos, case sensitivity (URLs are case-sensitive on most servers), and trailing slashes.',
    'If the resource was moved, set up a 301 redirect from the old URL to the new one. This preserves SEO value and fixes broken links.',
    'Check your server configuration — nginx/Apache location blocks, reverse proxy routes, or framework routing rules may not match the URL pattern.',
  ],
  monitoringTip:
    'A critical page returning 404 means lost traffic and revenue. Uptrack monitors your key URLs. If one starts returning 404, Uptrack detects it within 30 seconds and alerts you once several locations confirm it, so you can fix broken routes fast.',
}

export const Route = createFileRoute('/_site/http/404')({
  component: () => <HttpStatusPage data={data} />,
  head: () => httpStatusHead(data),
})
